import React, { useState, useEffect } from "react";
import axios from "axios";
import * as constants from "../constants/domains";
import Loading from "../components/ui/Loading";
import qs from "qs";
import { toast } from "react-toastify";
import * as helpers from "../helpers/helpers";
import { useCookies } from "react-cookie";
import VerificationInput from "react-verification-input";
import CountdownTimer from "../components/Counter";
//import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

function ConfirmMobile(props) {
  const [remaining, setRemaining] = useState(null);
  const [token, setToken] = useState("");
  const [loading, setLoading] = useState(false);
  const [validationError, setValidationError] = useState({});
  const [confirmTime, setConfirmTime] = useState({});
  const [confirmTimeLoading, setConfirmTimeLoading] = useState(false);
  const [sendVerCodeAgainLoading, setSendVerCodeAgainLoading] = useState(false);
  const [username, setUsername] = useState("");
  const [callBack, setCallBack] = useState("");
  const [site, setSite] = useState("");
  const setCookie = useCookies(["user_server_token"])[1];
  const [addToSegment, setAddToSegment] = useState(false);
  const [timer, setTimer] = useState("");
  const [sended, setSended] = useState(true);
  const [loadingFirst, setLoadingFirst] = useState(true);

  const [block, setBlock] = useState(false);

  const [ip, setIp] = useState(false);

  const { history } = props;
  const { location } = props;
//  const { executeRecaptcha } = useGoogleReCaptcha();

//  useEffect(() => {
//     if (executeRecaptcha) { 
//  const syntheticEvent = {
//        preventDefault: () => {},
//        stopPropagation: () => {},
//      };
//      sendVerCodeAgain(syntheticEvent);
//    }
    
//  }, [executeRecaptcha]);

  useEffect(() => {
    const queryParams = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (!queryParams) {
      history.push({
        pathname: "/user",
        search: "?site=shop",
      });
    } else if (
      queryParams["site"] !== "class" &&
      queryParams["site"] !== "shop"
    ) {
      history.push({
        pathname: "/user",
        search: "?site=shop",
      });
    } else if (!queryParams["token"]) {
      history.push({
        pathname: "/user",
        search: "?site=shop",
      });
    } else {
      try {
        console.log("username2",window.atob(queryParams["token"]));
        
        setUsername(window.atob(queryParams["token"]));
        getConfirmTime(window.atob(queryParams["token"]));
      } catch (e) {
        history.push({
          pathname: "/user",
          search: "?site=shop",
        });
      }
      setSite(queryParams["site"]);
      setCallBack(queryParams["callBack"] ? queryParams["callBack"] : "");
    }
    console.log(queryParams);
    if (queryParams && queryParams["addToSegment"] == "true") {
      setAddToSegment(true);
    } else {
      setAddToSegment(false);
    }
  }, [history, location]);

  useEffect(() => {
    const timer = setTimeout(() => {
      const remaining = confirmTime - Math.floor(Date.now() / 1000);
      if (remaining >= 0) {
        setRemaining(remaining);
      } else {
        setRemaining(0);
      }
    }, 1000);
    // Clear timeout if the component is unmounted
    return () => clearTimeout(timer);
  });

    useEffect(()=>{
    sendVerCodeAgain();
  },[username])
  
  const getConfirmTime = (data) => {
    setConfirmTimeLoading(true);
    document.body.style.overflow = "hidden";

    axios
      .post(constants.$apiUrl + "/api/confirm-time", {
        username: data,
      })
      .then((response) => {
        setConfirmTimeLoading(false);
        document.body.style.overflow = "unset";

        setConfirmTime(response.data.data.confirm_time);

        const remaining =
          response.data.data.confirm_time - Math.floor(Date.now() / 1000);
        if (remaining >= 0) {
          setRemaining(remaining);
        } else {
          setRemaining(0);
        }
      })
      .catch(() => {
        setConfirmTimeLoading(false);
        document.body.style.overflow = "unset";

        toast.error(
          "مشکلی پیش آمد لطفا دوباره تلاش کنید یا با پشتیبانی ارتباط برقرار کنید",
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          }
        );
      });
  };

  const formSubmit =  async(event) => {
    event.preventDefault();
   
    if (token !== "") {
      setLoading(true);
      setValidationError({});

      axios
        .post(constants.$apiUrl + "/api/confirm-mobile", {
          username: username,
           token: helpers.fa_to_eng_number(token),
          addToSegment,
        })
        .then((response) => {
          setLoading(false);

          if (response.data.success) {
            if (response.data.data.hasPassword) {
              let oneYear = Date.now() + 365 * 24 * 60 * 60 * 1000;
              setCookie("user_server_token", response.data.data.token, {
                domain: constants.$cookieURL,
                path: "/",
                expires: new Date(oneYear),
              });
              const callback = callBack ? callBack : "/";
              if (site === "class") {
                window.location.href = constants.$class_next_url + callback;
              } else {
                window.location.href =
                  constants.$shopUrl ;
              }
            } else {
              //console.log('ok');
              //console.log(username);
              const search = qs.stringify({
                site: site,
                callBack: callBack,
                token: window.btoa(helpers.fa_to_eng_number(username)),
                addToSegment: addToSegment,
              });
              //console.log(search);
              history.push({
                pathname: "register",
                search: "?" + search,
                state: { token: response.data.data.username },
              });
            }
          } else {
            toast.error(
              "مشکلی پیش آمد لطفا دوباره تلاش کنید یا با پشتیبانی ارتباط برقرار کنید",
              {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              }
            );
          }
        })
        .catch((error) => {
          setLoading(false);
          if (error.response) {
            if (error.response.status === 400) {
              setValidationError({ ...error.response.data.data });
            } else if (error.response.status === 409) {
              setValidationError({
                token: [error.response.data.message],
              });
            } else {
              toast.error(
                "مشکلی پیش آمد لطفا دوباره تلاش کنید یا با پشتیبانی ارتباط برقرار کنید",
                {
                  position: "top-right",
                  autoClose: 3000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                }
              );
            }
          } else {
            toast.error(
              "مشکلی پیش آمد لطفا دوباره تلاش کنید یا با پشتیبانی ارتباط برقرار کنید",
              {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              }
            );
          }
        });
    } else {
      setValidationError({ token: ["توکن نمیتواند خالی باشد."] });
    }
  };

  const sendVerCodeAgain = async (event) => {
    event?.preventDefault();
  //  if (!executeRecaptcha) {
      // alert("کپچا آماده نشده است !");
    //  event?.stopPropagation();
    //  return;
  //  }
  //  const tokenRecaptcha = await executeRecaptcha("submit");

  if(!username)
    return;
    setSendVerCodeAgainLoading(true);

    console.log("username", username);
    
    axios
      .post(constants.$apiUrl + "/api/resend-confirm-mobile", {
        username: username,
     //   captcha:tokenRecaptcha

      })
      .then((response) => {
        setSendVerCodeAgainLoading(false);
        setLoadingFirst(false); 

        if (response.data.success) {
          setConfirmTime(response.data.data.confirm_time);
          setRemaining(
            response.data.data.confirm_time - Math.floor(Date.now() / 1000)
          );
              setSended(true);

        } else {
          toast.error(
            "مشکلی پیش آمد لطفا دوباره تلاش کنید یا با پشتیبانی ارتباط برقرار کنید",
            {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            }
          );
        }
      })
      .catch((error) => {
        setSendVerCodeAgainLoading(false);
        if (error.response.status === 400) {
          if (error.response && error.response.data.data == "Limited") {
            if (error.response && error.response.data.limitTime > 0) {
              setTimer(error.response.data.limitTime);
            }
            if (error.response && error.response.data.limitTime == -1) {
              setBlock(true);
              setIp(error.response.data.ip);
            } else {
              setBlock(false);
              setIp(error.response.data.ip);
            }
            toast.error(
              "تعداد درخواست های شما به سرور زیاد شده است لطفا در زمانی دیگر تلاش کنید",
              {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              }
            );
          }
          setValidationError({ ...error.response.data.data });
        } else if (error.response.status === 409) {
          console.log(error.response);
        } else if (error.response.status === 500) {
          toast.error(
            "مشکلی پیش آمد لطفا دوباره تلاش کنید یا با پشتیبانی ارتباط برقرار کنید",
            {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            }
          );
        } else {
          toast.error(
            "مشکلی پیش آمد لطفا دوباره تلاش کنید یا با پشتیبانی ارتباط برقرار کنید",
            {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            }
          );
        }
      });
  };

  let minutes = Math.floor((remaining % (60 * 60)) / 60);
  let seconds = Math.floor(remaining % 60);
  return (
    <React.Fragment>
      {loadingFirst && <div>
        <strong style={{width:"100%",height:"100vh",display:"flex",justifyContent:"center",alignItems:"center",backgroundColor:"rgba(0,0,0,0.7)",position:"fixed",top:"0",left:"0",zIndex:"100000000",color:"white"}}>
          در حال ارسال کد
        </strong>
      </div>}
      <div className="container">
        <div className="card-group card-authentication mx-auto mb-5">
          <div className="login-card">
            <div className="card-content direction-rtl">
              <div className="form-header-logo">
                <img
                  src={constants.$authUrl + "/images/honari_logo.png"}
                  alt="هنری دات کام"
                />
                <div className="logo-text">
                  <p className="logo-honari-text">هـنـری</p>
                  <p className="logo-desc-text">تحقق رویای هنرمندانه‌ تو</p>
                </div>
              </div>
              {confirmTimeLoading ? <Loading /> : null}
              {sended ? <>
              
                       <div className={"form-header"}>کد تایید را وارد نمایید</div>
              <form onSubmit={(event) => formSubmit(event)}>
                <div className="mb-4 row">
                  <label htmlFor="token" className={"login-mobile-message"}>
                    {" "}
                    کد تایید برای شماره موبایل {username} ارسال گردید
                  </label>
                  <div className={"login-form-row"}>
                    <VerificationInput
                      id="token"
                      type="token"
                      className={
                        "form-field " +
                        (validationError["token"] &&
                        Array.isArray(validationError["token"])
                          ? "not-valid "
                          : "")
                      }
                      autoFocus={"auto"}
                      onChange={(event) => setToken(event)}
                      value={token}
                      length={4}
                      placeholder=""
                    />

                    {/* <input id="token"
                                               type="token"
                                               className={"form-field " + (validationError['token'] && Array.isArray(validationError['token']) ? 'not-valid ' : '')}
                                               autoFocus={'auto'}
                                               onChange={ (event) =>  setToken(event.target.value) }
                                               value={token}
                                        /> */}

                    {validationError["token"] &&
                    Array.isArray(validationError["token"])
                      ? validationError["token"].map((item, index) => {
                          return (
                            <div key={index} className={"validation-error"}>
                              {item}
                            </div>
                          );
                        })
                      : null}
                  </div>
                </div>

                {timer > 0 && (
                  <div className="mt-3">
                    <span className="pb-4 text-danger">
                      بدلیل درخواست زیاد درخواست شما محدود شده است
                    </span>
                    <div className="mt-2">
                      {" "}
                      <CountdownTimer minutes={timer} />
                    </div>
                  </div>
                )}
                {block && (
                  <span className="pb-4  text-danger">
                    بدلیل درخواست زیاد درخواست شما محدود شده است لطفا با
                    پشتیبانی تماس بگیرید
                    <br />
                    <span>ip : {ip}</span>
                    <br />
                  </span>
                )}

                {remaining > 0 ? (
                  <div className="login-resend-otp-message">
                    ارسال مجدد کد تا{" "}
                    {minutes.toString().length === 1
                      ? "0" + minutes.toString()
                      : minutes.toString()}
                    :
                    {seconds.toString().length === 1
                      ? "0" + seconds.toString()
                      : seconds.toString()}{" "}
                    دیگر
                  </div>
                ) : (
                  <button
                    disabled={sendVerCodeAgainLoading}
                    onClick={sendVerCodeAgain}
                    type="button"
                    className="btn w-100 send-otp-confirm-code"
                  >
                    {sendVerCodeAgainLoading ? (
                      <React.Fragment>در حال ارسال ...</React.Fragment>
                    ) : (
                      <React.Fragment>دریافت مجدد کد تایید</React.Fragment>
                    )}
                  </button>
                )}

                <div className="row">
                  <div className={"my-3"}>
                    {loading ? (
                      <button
                        disabled={true}
                        className="btn btn-honari w-100 py-2"
                      >
                        در حال ارسال اطلاعات...
                      </button>
                    ) : (
                      <button className="btn btn-honari w-100 py-2">
                        ادامه
                      </button>
                    )}
                  </div>
                </div>
              </form>
              </>
            :
            <div className="row ">
               <div className={"form-header text-center"}>جهت ثبت‌نام کد تایید را دریافت نمایید </div>

 <label htmlFor="token" className={"login-mobile-message"}>
                    {" "}
                    کد تایید برای شماره موبایل {username} ارسال میگردد
                  </label>
               <VerificationInput
                      id="test"
                      type="test"
                      className={ "form-field " }  
                      value={""}
                      length={4}
                      disabled={true}
                      placeholder=""
                    />

                      <button className="btn btn-honari w-100 py-2 mt-5"
                    disabled={sendVerCodeAgainLoading}
                    onClick={sendVerCodeAgain} 
                  >
                    دریافت کد
                  </button>
              </div>  
            } 
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default ConfirmMobile;
